import { render, staticRenderFns } from "./HandleSettingDialog.vue?vue&type=template&id=36181de2"
import script from "./HandleSettingDialog.vue?vue&type=script&lang=js"
export * from "./HandleSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports